import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = 'https://xhpubboxjmhmkcdyzetu.supabase.co';
const SUPABASE_PUBLISHABLE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhocHViYm94am1obWtjZHl6ZXR1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg2MDIwNzUsImV4cCI6MjA5NDE3ODA3NX0.FqSaVQFZfpzeZ-fxvQxG81YlCfft-UnzHNdq-P6Bkck';

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});